import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { ModalsProvider } from "./app/context/modals-context";

import AdminLayout from "./app/providers/AdminLayout";
import { ClientsPage } from "./pages/clients-list";
import HomePage from "./pages/home";
import AuthPage from "./pages/auth/AuthPage";

import ProtectedRoute from "./app/providers/ProtectedRoute";
import ToastContainer from "./shared/ui/toast/ToastContainer";
import ReviewsPage from "./pages/reviews-list/ReviewsPage";
import ReviewRewritePage from "./pages/review-rewrite/ReviewRewrite";
import { TeamPage } from "./pages/team-list";
import { TeamRewritePage } from "./pages/team-rewrite";
import { ProgramsPage } from "./pages/programs-list";
import { ProgramsRewritePage } from "./pages/programs-rewrite";
import { ProgramsContentEditPage } from "./pages/programs-content-edit";
import { PlacementTestsPage } from "./pages/placement-tests-list";
import { QuickPlacementTestsPage } from "./pages/quick-placement-tests-list";
import { PlacementTestsRewritePage } from "./pages/placement-tests-rewrite";
import { QuickPlacementTestsRewritePage } from "./pages/quick-placement-tests-rewrite";
import { PlacementTestSessionsPage } from "./pages/placement-tests-sessions";
import { QuickPlacementTestSessionsPage } from "./pages/quick-placement-tests-sessions";
import { PlacementTestSessionDetailPage } from "./pages/placement-tests-session-detail";
import { KidsTestsPage } from "./pages/kids-tests-list";
import { KidsTestsRewritePage } from "./pages/kids-tests-rewrite";
import { KidsTestSessionsPage } from "./pages/kids-tests-sessions";
import { KidsTestSessionDetailPage } from "./pages/kids-tests-session-detail";


function App() {
  return (
    <ModalsProvider>
      <ToastContainer />
      <BrowserRouter>
        <Routes>

          <Route path="/auth" element={<AuthPage />} />


          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<AdminLayout />}>
              <Route index element={<HomePage />} />
              <Route path="users" element={<ClientsPage />} />
              <Route path="reviews" element={<ReviewsPage />} />
              <Route path="review-rewrite/:id" element={<ReviewRewritePage />} />
              <Route path="team" element={<TeamPage />} />
              <Route path="team-rewrite/:id" element={<TeamRewritePage />} />
              <Route path="programs" element={<ProgramsPage />} />
              <Route path="programs-rewrite/:id" element={<ProgramsRewritePage />} />
              <Route path="programs-content-edit/:programId" element={<ProgramsContentEditPage />} />
              <Route path="placement-tests" element={<PlacementTestsPage />} />
              <Route path="placement-tests-rewrite/:templateId" element={<PlacementTestsRewritePage />} />
              <Route path="quick-placement-tests" element={<QuickPlacementTestsPage />} />
              <Route path="quick-placement-tests-rewrite/:templateId" element={<QuickPlacementTestsRewritePage />} />
              <Route path="placement-tests-sessions" element={<PlacementTestSessionsPage />} />
              <Route path="placement-tests-sessions/:sessionId" element={<PlacementTestSessionDetailPage />} />
              <Route path="quick-placement-tests-sessions" element={<QuickPlacementTestSessionsPage />} />
              <Route path="kids-tests" element={<KidsTestsPage />} />
              <Route path="kids-tests-rewrite/:templateId" element={<KidsTestsRewritePage />} />
              <Route path="kids-tests-sessions" element={<KidsTestSessionsPage />} />
              <Route path="kids-tests-sessions/:sessionId" element={<KidsTestSessionDetailPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ModalsProvider>
  );
}

export default App;
